// extracted by mini-css-extract-plugin
export default {"main":"TipoEventoSelector_main__9HZ2n","option":"TipoEventoSelector_option__mo5Ho"};